import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgNotification = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M11 4c0 .028.001.055.003.082A6.002 6.002 0 0 0 6 10v5.586l-1.707 1.707A1 1 0 0 0 5 19h14a1 1 0 0 0 .707-1.707L18 15.586V10a6.002 6.002 0 0 0-5.003-5.918C12.999 4.055 13 4.028 13 4V3a1 1 0 1 0-2 0v1Zm1 2a4 4 0 0 1 4 4v6a1 1 0 0 0 .293.707l.293.293H7.414l.293-.293A1 1 0 0 0 8 16v-6a4 4 0 0 1 4-4ZM12 22a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z" />
  )
export default SvgNotification
